export enum LocationAvailabilityEnum {
  "AVAILABLE" = "AVAILABLE",
  "PARTIALLY" = "PARTIALLY",
  "NOT_AVAILABLE" = "NOT_AVAILABLE",
  "CURRENTLY_INSTALLING" = "CURRENTLY_INSTALLING",
  "PARTIALLY_BOOKED" = "PARTIALLY_BOOKED",
  "TEMPORARILY_SUSPENDED" = "TEMPORARILY_SUSPENDED",
  "MAINTENANCE" = "MAINTENANCE",
}

// Statuses driven by the location partner state rather than by its booked dates.
export const OPERATIONAL_LOCATION_AVAILABILITIES: LocationAvailabilityEnum[] = [
  LocationAvailabilityEnum.CURRENTLY_INSTALLING,
  LocationAvailabilityEnum.TEMPORARILY_SUSPENDED,
  LocationAvailabilityEnum.MAINTENANCE,
];

// Statuses for which a location partner is out of service and cannot be booked.
export const SUSPENDED_LOCATION_AVAILABILITIES: LocationAvailabilityEnum[] = [
  LocationAvailabilityEnum.TEMPORARILY_SUSPENDED,
  LocationAvailabilityEnum.MAINTENANCE,
];
